import { keepPreviousData, useQuery } from '@tanstack/react-query';

import NlsAnalyticsService, { Category3QueriesParams } from '~/services/NlsAnalyticsService';

import { nlsAnalyticsQueryKeys } from './nlsAnalyticsQueryKeys';
import { nlsAnalyticsQueryOptions } from './nlsAnalyticsQueryOptions';

export function useCategory3Queries({ limit, offset }: Required<Category3QueriesParams>) {
  return useQuery({
    queryKey: nlsAnalyticsQueryKeys.category3Queries(limit, offset),
    queryFn: () => NlsAnalyticsService.getCategory3Queries({ limit, offset }),
    placeholderData: keepPreviousData,
    select: (data) => data.result,
    ...nlsAnalyticsQueryOptions,
  });
}
